<header class="top-nav" id="top-nav-id" aria-label="Top Navigation">
  <div class="left">
    <h1 class="mb-0 d-flex align-items-center">
      @if (!sideNavVisible) {
        <img
          src="assets/menu.svg"
          alt="Open navigation menu"
          class="d-none hamburger-icon me-2"
          (click)="onSideNav()"
          role="button"
          tabindex="0"
          aria-label="Open side navigation"
          aria-controls="side-nav-id"
        />
      } @else {
        <img
          src="assets/close-white.svg"
          alt="Close navigation menu"
          class="d-none close-icon me-2"
          (click)="onSideNav()"
          role="button"
          tabindex="0"
          aria-label="Close side navigation"
          aria-controls="side-nav-id"
        />
      }
      <h2 class="m-0 p-4 main-logo">
        {{ logoHeader }}
      </h2>
    </h1>
  </div>
  <div class="right">
    @if (userData) {
      <div
        role="button"
        class="avatar-container"
        [matMenuTriggerFor]="menu"
        tabindex="0"
        (keydown)="onMenuKeydown($event)"
        aria-haspopup="menu"
        aria-label="User menu"
      >
        <div class="avatar-with-username">
          <div class="success d-flex align-items-center">
            <div
              role="button"
              class="text-avatar-container"
              (keydown)="onMenuKeydown($event)"
            >
              <div class="text-avatar" aria-label="User initials">
                {{ userData.loginData?.firstName | slice: 0 : 1
                }}{{ userData.loginData?.lastName | slice: 0 : 1 }}
              </div>
            </div>
          </div>
          <span
            class="d-none d-sm-block"
            [attr.aria-label]="
              'Logged in as ' +
              userData.loginData?.firstName +
              ' ' +
              userData.loginData?.lastName
            "
            title="{{ userData.loginData?.firstName }} {{
              userData.loginData?.lastName
            }}"
          >
            {{ userData.loginData?.firstName }}
            {{ userData.loginData?.lastName }}
          </span>
        </div>
      </div>

      <mat-menu #menu="matMenu" class="profile-menu-container">
        <div class="d-flex align-items-center mb-2">
          <div class="user-login">
            <div class="success d-flex align-items-center">
              <div role="button" class="text-avatar-container">
                <div class="text-avatar" aria-label="User initials">
                  {{ userData.loginData?.firstName | slice: 0 : 1
                  }}{{ userData.loginData?.lastName | slice: 0 : 1 }}
                </div>
              </div>
            </div>
          </div>
          <div class="user-details">
            <div class="user-name" aria-label="User name">
              {{ userData.loginData?.firstName }}
              {{ userData.loginData?.lastName }}
            </div>
            @if (userData.loginData?.email) {
              <div class="user-email" aria-label="User email">
                {{ userData.loginData?.email }}
              </div>
            }
          </div>
        </div>
        <div class="profile-menu-options">
          <ul role="menu" aria-label="Profile menu">
            <li
              (click)="changePassword()"
              role="menuitem"
              tabindex="0"
              aria-label="Change Password"
            >
              <img src="/assets/shield.svg" alt="" aria-hidden="true" />
              <p>Change Password</p>
            </li>

            <hr />

            <li
              (click)="logout()"
              role="menuitem"
              tabindex="0"
              aria-label="Logout"
            >
              <img src="/assets/logout.svg" alt="" aria-hidden="true" />
              <p>Logout</p>
            </li>
          </ul>
        </div>
      </mat-menu>
    }
  </div>
</header>
